export enum OperationalMode {
  Default,
  Kiosk,
}

export const operationalMode =
  process && process.env?.REACT_APP_MODE === "kiosk"
    ? OperationalMode.Kiosk
    : OperationalMode.Default;
